/**
 * Ryan O'Dowd
 * 2022-08-05
 * © Copyright 2022 Oakwood Software Consulting, Inc. All Rights Reserved.
 */

const getStyles = ({globalScale, colors, isDarkMode, isDense}) => {
  return {
    container: {
    },
    denseContainer: {
      paddingHorizontal: 0,
    },
    listItemInner: {
      /* @TODO: right idea, but margins get thrown off
      transform: [
        { scale: isDense ? 0.75 : 1 },
      ],
      */
      borderWidth: 0,
      borderWidthBottom: 2,
      borderColor: isDarkMode ? colors.primary : colors.primaryLight,
      backgroundColor: isDarkMode ? `${colors.primaryExtraDark}44` : `${colors.primaryDark}44`,
      padding: 2,
      margin: 0,
      marginVertical: 2,
    },
    photosAndNamesRow: {
      display: 'flex',
      flexDirection: 'row',
      width: '100%',
    },
    profilePicture: {
      width: globalScale * (isDense ? 34 : 50),
      height: globalScale * (isDense ? 34 : 50),
    },
    imageStyles: {
      borderWidth: globalScale * 2,
      borderRadius: globalScale * 12,
    },
    namesWrapper: {
      flex: 1,
      justifyContent: 'center',
      marginLeft: 8,
    },
    displayName: {
      fontSize: globalScale * (isDense ? 16 : 20),
      color: colors.white,
    },
    username: {
      fontSize: globalScale * 16,
      color: colors.white,
    },
    dailyPeanutCount: {
      fontSize: globalScale * (isDense ? 14 : 16),
      color: colors.accent,
    },
    followButtonWrapper: {
      position: 'absolute', // @TODO: would prefer that this isn't absolutely positioned
      top: 0,
      right: 0,
      display: 'flex',
      flexDirection: 'row',
    },
    stats: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      width: '100%',
      justifyContent: 'space-between',
      marginTop: 4,
    },
    statWrapper: {
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
    },
    statLabel: {
      color: colors.white,
      fontSize: globalScale * 14,
    },
    wrinklingSince: {
      color: colors.white,
      fontSize: globalScale * 12,
    },
    statValueWrapper: {
      backgroundColor: colors.primaryDark, // @TODO: no color if 0 or low; gold if streak over 100 or wrinkles/peanuts in top 10% of users
      borderRadius: globalScale * 8,
      padding: globalScale * 2,
      margin: globalScale * 2,
      paddingLeft: globalScale * 4,
      paddingRight: globalScale * 4,
    },
    statValue: {
      color: colors.white,
      fontSize: globalScale * 12,
    },
  };
};

export default getStyles;
